import { FC, useEffect, useState } from 'react';
import { GroupStudentSeriesScores } from '../../../../config/api/models/Score';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import {
  setIsFetching,
  setIsOutdated,
  setNoResultsFound,
} from 'src/modules/shared/slices/filters/entity/FiltersSlice';
import { useGetPageScoreByGroupMutation } from 'src/modules/shared/slices/score-progress/score';

type Props = {
  pageId: string;
  onChange: (value?: GroupStudentSeriesScores) => void;
  shouldReFetch: boolean;
};

const GroupTrajectoryScoresHandler: FC<Props> = ({ pageId, onChange, shouldReFetch }) => {
  const dispatch = useAppDispatch();
  const selectedGroup = useAppSelector((state) => state.filters.selectedGroup);
  const refresh = useAppSelector((state) => state.filters.refresh);
  const [previousCall, setPreviouCall] = useState<any | undefined>();
  const [previousSelectedGroupId, setPreviousSelectedGroupId] = useState(selectedGroup);
  const [
    getPageScoreByGroup,
    {
      data: getTrajectoryScoresByGroupResponse,
      isError: getTrajectoryScoresByGroupError,
      isSuccess: getTrajectoryScoresByGroupSuccess,
      isLoading: reFetchInProgress,
    },
  ] = useGetPageScoreByGroupMutation();

  useEffect(() => {
    if (getTrajectoryScoresByGroupError) {
      dispatch(setNoResultsFound(true));
      onChange();
    }
  }, [getTrajectoryScoresByGroupError, onChange, dispatch]);

  useEffect(() => {
    if (getTrajectoryScoresByGroupSuccess && getTrajectoryScoresByGroupResponse) {
      onChange(getTrajectoryScoresByGroupResponse);
      dispatch(setNoResultsFound(false));
      dispatch(setIsOutdated(getTrajectoryScoresByGroupResponse.isOutdated));
    }
  }, [getTrajectoryScoresByGroupResponse, getTrajectoryScoresByGroupSuccess, onChange, dispatch]);

  useEffect(() => {
    if (!selectedGroup) return;
    if (
      !reFetchInProgress &&
      (shouldReFetch || refresh || previousSelectedGroupId !== selectedGroup || previousCall === undefined)
    ) {
      setPreviousSelectedGroupId(selectedGroup);
      previousCall?.abort();

      const newApiCall = getPageScoreByGroup({ pageId, groupId: selectedGroup });
      setPreviouCall(newApiCall);
    }
  }, [
    shouldReFetch,
    reFetchInProgress,
    getPageScoreByGroup,
    refresh,
    pageId,
    previousCall,
    selectedGroup,
    previousSelectedGroupId,
  ]);

  useEffect(() => {
    dispatch(setIsFetching(reFetchInProgress));
  }, [reFetchInProgress, dispatch]);

  return null;
};

export default GroupTrajectoryScoresHandler;
